import React from "react";
import { motion } from "framer-motion";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

interface StatCardProps {
  label: string;
  value: string | number;
  icon: React.FC<any>;
  color?: string;
  trend?: { direction: "up" | "down" | "flat"; label: string };
}

const trendConfig = {
  up: { Icon: TrendingUp, color: "text-emerald-600", bg: "bg-emerald-50" },
  down: { Icon: TrendingDown, color: "text-red-600", bg: "bg-red-50" },
  flat: { Icon: Minus, color: "text-slate-500", bg: "bg-slate-50" },
};

const StatCard: React.FC<StatCardProps> = ({
  label,
  value,
  icon: Icon,
  color = "#0F5132",
  trend,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-xl shadow-sm border border-slate-200 p-5"
    >
      <div className="flex items-center justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-slate-500 truncate">{label}</p>
          <p className="text-2xl font-bold text-slate-800 mt-1">{value}</p>
          {trend && (
            <div className="flex items-center gap-1.5 mt-2">
              {(() => {
                const cfg = trendConfig[trend.direction];
                const TrendIcon = cfg.Icon;
                return (
                  <span
                    className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${cfg.color} ${cfg.bg}`}
                  >
                    <TrendIcon className="h-3 w-3" />
                    {trend.label}
                  </span>
                );
              })()}
            </div>
          )}
        </div>
        <div
          className="p-3 rounded-xl flex-shrink-0"
          style={{ backgroundColor: `${color}1A` }}
        >
          <Icon className="h-5 w-5" style={{ color }} />
        </div>
      </div>
    </motion.div>
  );
};

export default StatCard;
